import React from "react";
import { Grid, Button, Box } from "@material-ui/core";
import BankAccountFieldContainer from "./BankAccountField/BankAccountFieldContainer";
import ReasonSelect from "./ReasonSelect/ReasonSelect";
import PaymentAmountInput from "./PaymentAmountInput/PaymentAmountInput";
import TransferFeeLabel from "./TransferFeeLabel/TransferFeeLabel";
import AdditionalNotesTextField from "./AdditionalNotesTextField/AdditionalNotesTextField";
import { CreateDisbursementFormFields, useCreateDisbursementForm } from "./Hooks/useCreateDisbursementForm";
import useDisbursements from "../Hooks/useDisbursementsHook";
import { useEmployeeProfileQuery } from "Hooks/useEmployeeProfileQueryContext";
import pretty from "Shared/pretty";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { useFormContext } from "react-hook-form";
import isNumber from "lodash/isNumber";

type OffCyclePaymentFormProps = {
  onSubmit: () => void;
  employeeProfileId: string;
  userId: string;
};

const OffCyclePaymentForm = ({
  onSubmit,
  employeeProfileId,
  userId
}: OffCyclePaymentFormProps) => {
  const { offCyclePaymentOptions } = usePartnerConfig();
  const { userDetails } = useEmployeeProfileQuery();
  const { refetchQueries } = useDisbursements(employeeProfileId);

  const { watch } = useFormContext<CreateDisbursementFormFields>();
  const isBankAccountExisting = watch("bankAccountOptionRadioGroup") === "EXISTING";
  const bankAccountOption = watch("bankAccountOption");
  const isDPASelected = isBankAccountExisting &&
    userDetails?.employee.providerBankAccount &&
    userDetails?.employee.providerBankAccount.id === bankAccountOption?.value;
  const cycleFee = isDPASelected
    ? offCyclePaymentOptions.cycleDpaFeeCents
    : offCyclePaymentOptions.cycleUserBankFeeCents;

  const { GetDisbursementFormRow } = useCreateDisbursementForm(
    employeeProfileId,
    refetchQueries
  );

  if (!userDetails) {
    return null;
  }

  return (
    <>
      <Grid container direction={"column"} spacing={2}>
        {userId &&
          GetDisbursementFormRow("User ID", userId)}
        {GetDisbursementFormRow("Payment Amount ($)", <PaymentAmountInput />)}
        {
          isNumber(cycleFee) &&
            GetDisbursementFormRow(<TransferFeeLabel />, pretty.dollar(cycleFee))
        }
        {userDetails.employee.userBankAccounts &&
          GetDisbursementFormRow(
            "Select Bank Account",
            <BankAccountFieldContainer />
          )}
        {GetDisbursementFormRow("Reason", <ReasonSelect />)}
        {GetDisbursementFormRow(
          "Additional Notes",
          <AdditionalNotesTextField />
        )}
      </Grid>
      <Box textAlign={"center"} marginTop={4}>
        <Button
          color="primary"
          onClick={onSubmit}
          size="large"
          variant="contained"
        >
          Submit Payment
        </Button>
      </Box>
    </>
  );
};

export default OffCyclePaymentForm;
